import React from "react";
import { Box, Typography, CardContent, Divider } from "@mui/material";
import { StyledCard } from "../../common/StyledCard";
import { getEntityMeta } from "../../../helpers/dashboardHelpers";
import { formatCurrency } from "../../../utils/currencyUtils";
import { InvoiceStatsDto } from "../../../shared/dtos/invoice/InvoiceStatsDto";

interface InvoiceWidgetProps {
  data: InvoiceStatsDto;
}

const InvoiceWidget: React.FC<InvoiceWidgetProps> = ({ data }) => {
  const meta = getEntityMeta("INVOICE");
  const Icon = meta.icon;

  return (
    <StyledCard sx={{ height: "100%" }}>
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
          <Box
            sx={{
              p: 1,
              borderRadius: 1,
              bgcolor: `${meta.color}15`,
              color: meta.color,
              display: "flex",
              mr: 2,
            }}
          >
            <Icon />
          </Box>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            {meta.title}
          </Typography>
        </Box>

        <Box sx={{ textAlign: "center", mb: 3 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Expected Revenue Today
          </Typography>
          <Typography
            variant="h4"
            sx={{ fontWeight: "bold", color: "info.main" }}
          >
            {formatCurrency(data.expectedRevenueToday)}
          </Typography>
        </Box>

        <Divider sx={{ mb: 2 }} />

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: 2,
            textAlign: "center",
          }}
        >
          <Box>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              Draft
            </Typography>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              {data.draftToday}
            </Typography>
          </Box>
          <Box>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              Issued
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: "bold", color: "success.main" }}
            >
              {data.issuedToday}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </StyledCard>
  );
};

export default InvoiceWidget;
